// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3zV2O","tab":"ProcedureTabs_tab__2gAG5"};